/**
 * What the schedule is blocked from doing, so the same sentence can say "cannot
 * be edited" on the editor and "cannot be archived" on the archive menu item.
 */
export type LockedScheduleAction = 'edited' | 'archived'

/**
 * Used when we can't name the quote - usually because the user has no
 * permission to read quotes, so it's one they couldn't open anyway.
 */
export const UNNAMED_AMENDMENT_QUOTE = 'an amendment quote'

/**
 * Everything up to the quote name. Split out so the name can be a link in the
 * tooltip and the banner, and plain text in a menu item's tooltip, which only
 * takes a string.
 */
export const amendmentLockSentenceStart = (action: LockedScheduleAction) =>
  `This schedule cannot be ${action} because it is being amended by `

export const amendmentLockSentence = (
  action: LockedScheduleAction,
  quoteName: string
) => `${amendmentLockSentenceStart(action)}${quoteName}.`
